import { Module } from 'vuex';
import IRootState from '@/store/types/IRootState';
import AppState from './types/AppState';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const app: Module<AppState, IRootState> = {
  namespaced: true,
  state: {
    version: '',
    locale: '',
    error: {},
  },
  actions,
  getters,
  mutations,
};

export default app;
